import { Reveal } from "@/components/Reveal";
import { SectionTitle } from "@/components/Practice";

const ADVISORY =
  "https://images.unsplash.com/photo-1522071901873-411886a10004?fm=jpg&q=85&w=1600&auto=format&fit=crop";
const TABLE =
  "https://images.unsplash.com/photo-1616587224026-668840f26916?fm=jpg&q=85&w=1600&auto=format&fit=crop";

const STORIES = [
  {
    id: "consulting",
    category: "Consulting",
    title: "Business performance, engineered",
    dek: "A practice built on strategy, transformation, finance, and advisory. We work inside your numbers and your operations to lift performance — measurably.",
    img: ADVISORY,
    alt: "A relaxed one-on-one working session over a laptop",
  },
  {
    id: "marketplace",
    category: "B2B Marketplace",
    title: "One database, both sides of the table",
    dek: "A web-based marketplace connecting buyers and suppliers. Buyers list requirements; suppliers get discovered. Direct connection, no middle layers.",
    img: TABLE,
    alt: "Two people meeting over a laptop at a cafe table",
  },
];

export default function FeatureStories() {
  return (
    <section id="services" data-testid="services-section" className="border-t border-[#E5E5DE] py-20 md:py-28">
      <SectionTitle kicker="The Practice" title="Consulting first. Marketplace second. Results, always." />
      <div className="mt-14 md:mt-16">
        <SectionTitle kicker="What We Do" title="Two Pillars" />
      </div>
      <div className="max-w-[1200px] mx-auto px-6 mt-16 grid grid-cols-1 md:grid-cols-2 gap-12">
        {STORIES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.12}>
            <article data-testid={`pillar-${s.id}`} className="group">
              <div className="overflow-hidden">
                <img
                  src={s.img}
                  alt={s.alt}
                  className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <p className="mt-6 text-[11px] font-semibold tracking-[0.3em] uppercase text-[#4C8C1E]">
                {s.category}
              </p>
              <h3 className="mt-3 font-serif text-3xl md:text-4xl leading-[1.15] text-[#16180F] group-hover:underline decoration-[#4C8C1E] underline-offset-4">
                {s.title}
              </h3>
              <p className="mt-4 text-base font-light text-[#55564A] leading-relaxed">{s.dek}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
